import isEmpty from 'lodash/isEmpty'
import sumBy from 'lodash/sumBy'

import type { IncludedIncomeStream } from 'renter/interfaces/api/income'
import FlexContainer from 'shared/components/FlexContainer'
import Tile from 'shared/components/Tile'
import { MediumTitle, SmallText } from 'shared/components/Typography'
import { COLORS } from 'shared/config/constants'
import { printDollarsFromCents } from 'shared/utils/dollar-print'

import { IncomeStreamsTable } from './IncomeStreamsTable'

interface IncludedIncomeProps {
  streams: IncludedIncomeStream[]
  canViewOcrResults: boolean
  canEditOcrResults: boolean
  editedIncome?: number
}

export const IncludedIncomeSection = ({
  streams,
  canViewOcrResults,
  canEditOcrResults,
  editedIncome,
}: IncludedIncomeProps) => {
  const isEdited = editedIncome !== null && editedIncome !== undefined
  const hasVerifiedStreams = !isEmpty(streams)
  return (
    <Tile
      id="verified-income"
      header={{
        title: <MediumTitle>Verified Income</MediumTitle>,
        subtitle: (hasVerifiedStreams || isEdited) && (
          <FlexContainer flexDirection="column">
            {hasVerifiedStreams && (
              <>
                <SmallText extraStrong>Total Projected Annual Income</SmallText>
                <MediumTitle
                  style={{
                    color: isEdited
                      ? COLORS.secondary
                      : COLORS.violetTheme.lightViolet2,
                    textDecoration: isEdited ? 'line-through' : undefined,
                  }}
                >
                  {printDollarsFromCents(
                    sumBy(
                      streams,
                      ({ estimatedAnnualGrossAmount, estimatedAnnualNetAmount }) =>
                        estimatedAnnualGrossAmount ?? estimatedAnnualNetAmount ?? 0,
                    ),
                  )}
                </MediumTitle>
              </>
            )}
            {isEdited && (
              <>
                <SmallText extraStrong>Manager-edited Total</SmallText>
                <MediumTitle
                  style={{ color: COLORS.violetTheme.lightViolet2 }}
                >
                  {printDollarsFromCents(editedIncome)}
                </MediumTitle>
              </>
            )}
          </FlexContainer>
        ),
        withoutBorderBottom: true,
      }}
      rounded
    >
      <IncomeStreamsTable
        streams={streams}
        type="included"
        canViewOcrResults={canViewOcrResults}
        canEditOcrResults={canEditOcrResults}
      />
    </Tile>
  )
}
